import { Alert } from '@mui/material';
import { Link } from 'react-router-dom';

export const BasketRegisterAlert = () => {
  return (
    <Alert severity='info'>
      Hesap oluşturmadan alışveriş yapabilirsiniz, ancak üye olarak ekstra
      avantajlardan faydalanabilirsiniz!{' '}
      <Link to='/giris-yap'>Hemen üye olun</Link> ve kazanmaya başlayın. Üyelik
      size özel indirimler, puanlar ve daha fazlasını getirir!
    </Alert>
  );
};
